import React from 'react';
import { Link } from 'react-router-dom';
import './NewsEvents.scss';

const NewsEvents = () => {
  return (
    <section className="news-events" aria-label="News and Events">
      <div className="news-events__container">
        
        {/* Hero Announcement Card */}
        <article className="news-card news-card--hero">
          <div className="news-card__bg-pattern"></div>
          <div className="news-card__content">
            <span className="news-card__eyebrow">Welcome to</span>
            <h2 className="news-card__title">
              Crave Café
              <span className="news-card__title-accent">Studio City</span>
            </h2>
            <div className="news-card__divider"></div>
            <p className="news-card__subtitle">A New Chapter Begins</p>
            <p className="news-card__badge">Under New Management</p>
            <div className="news-card__actions">
              <Link to="/pasadena/order" className="news-btn news-btn--primary">
                <span>Order Online</span>
                <span className="news-btn__cashback">5% Cashback</span>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M5 12h14M12 5l7 7-7 7"/>
                </svg>
              </Link>
              <Link to="/menu" className="news-btn news-btn--outline">
                View Menu
              </Link>
            </div>
          </div>
        </article>

        {/* Open Mic Event Card */}
        <article className="news-card news-card--event">
          <div className="news-card__content">
            <div className="event-badge">
              <span className="event-badge__icon">🎤</span>
              <span className="event-badge__label">Live Event</span>
            </div>
            
            <h3 className="event__title">Open Mic Night</h3>
            <p className="event__tagline">Let's Mic Together</p>
            
            <p className="event__description">
              Join us for a night of creativity, connection, and community at Crave Café.
            </p>
            
            <div className="event__details">
              <div className="event__detail">
                <div className="event__detail-icon">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
                    <line x1="16" y1="2" x2="16" y2="6"/>
                    <line x1="8" y1="2" x2="8" y2="6"/>
                    <line x1="3" y1="10" x2="21" y2="10"/>
                  </svg>
                </div>
                <div className="event__detail-text">
                  <span className="event__detail-label">Date</span>
                  <span className="event__detail-value">January 27</span>
                </div>
              </div>
              
              <div className="event__detail">
                <div className="event__detail-icon">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M9 18V5l12-2v13"/>
                    <circle cx="6" cy="18" r="3"/>
                    <circle cx="18" cy="16" r="3"/>
                  </svg>
                </div>
                <div className="event__detail-text">
                  <span className="event__detail-label">Performances</span>
                  <span className="event__detail-value">Music • Poetry • Comedy</span>
                </div>
              </div>
              
              <div className="event__detail">
                <div className="event__detail-icon">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/>
                    <circle cx="12" cy="10" r="3"/>
                  </svg>
                </div>
                <div className="event__detail-text">
                  <span className="event__detail-label">Location</span>
                  <span className="event__detail-value">Crave Café – Studio City</span>
                </div>
              </div>
            </div>
          </div>
        </article>

      </div>
      
      {/* Floating CTA */}
      <div className="news-events__cta">
        <Link to="/pasadena/order" className="cta-btn">
          <span className="cta-btn__text">Order Online</span>
          <span className="cta-btn__cashback">5% Cashback</span>
          <span className="cta-btn__icon">→</span>
        </Link>
      </div>
    </section>
  );
};

export default NewsEvents;
